export default () => ({
  currencySetting: {}
});
